import {
  AfterViewInit,
  Component,
  inject,
  Injector,
  input,
  runInInjectionContext,
  TemplateRef,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { IonAccordion, IonAccordionGroup } from '@ionic/angular/standalone';
import { ParkourIconComponent } from '@parkour/ui';

@Component({
  standalone: true,
  selector: 'parkour-accordion',
  styleUrls: ['./parkour-accordion.component.css'],
  templateUrl: './parkour-accordion.component.html',
  imports: [ParkourIconComponent, IonAccordion, IonAccordionGroup, NgTemplateOutlet],
})
export class ParkourAccordionComponent<T extends object & { reference?: string }>
  implements AfterViewInit
{
  public readonly items = input.required<T[]>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public readonly titleTemplate = input.required<TemplateRef<any>>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public readonly contentTemplate = input.required<TemplateRef<any>>();
  public readonly initiallyActiveItem = input<string>('');

  private readonly injector = inject(Injector);

  ngAfterViewInit(): void {
    runInInjectionContext(this.injector, () => {
      if (
        this.initiallyActiveItem() &&
        this.items()
          .map((value) => value.reference)
          .includes(this.initiallyActiveItem())
      ) {
        const elementById = document.getElementById(`accordion-${this.initiallyActiveItem()}`);
        setTimeout(() => {
          elementById?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 0);
      }
    });
  }
}
